import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AbstractEmployeeAddComponent, mapStateToProps } from './abstract'
import { Sidebar } from '~/components/sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Header } from '~/components/header'
import { Table } from '~/components/table'
import * as route from '~/helper/constant/route'
import { Button, Input, TextArea } from '~/components/form'
import MultiImageInput from 'react-multiple-image-input'
import { Loading } from '~/components/loader'
import Select from 'react-select'
import Files from 'react-files'
import DatePicker from 'react-datepicker'
import $ from 'jquery'
import { withTranslation } from 'react-i18next'
import moment from 'moment'
import { convertADtoBS } from '../../../../../helper/function'

class EmployeeAddComponent extends AbstractEmployeeAddComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
        this.setDate = this.setDate.bind(this)
        this.setEmployeeCategory = this.setEmployeeCategory.bind(this)
        this.setJoinDate = this.setJoinDate.bind(this)
        this._selectUserType = this._selectUserType.bind(this)
        this._selectCustomRole = this._selectCustomRole.bind(this)
    }

    _selectUserType(data) {
        if (data.value == 1) {
            $('#custom-role').show()
            this.setState({
                selectedUserType: data.value,
                defaultUserType: data,
                selectedRole: this.state.customRoleAry[0].value,
                defaultRole: this.state.customRoleAry[0],
                user_type: data.value,
                role_id: this.state.customRoleAry[0].value,
            })
        } else {
            $('#custom-role').hide()
            this.setState({
                selectedUserType: data.value,
                defaultUserType: data,
                user_type: data.value,
                role_id: 0,
                selectedRole: 0,
                defaultRole: null,
            })
        }
    }

    _selectCustomRole(data) {
        super._handleChange('selectedRole', data.value)
        super._handleChange('defaultRole', data)
        super._handleChange('role_id', data.value)
    }

    setEmployeeCategory(data) {
        super._handleChange('selectedEmployeCategory', data.value)
    }
    setDate(data) {
        super._handleChange('dob', data)
    }

    setJoinDate(data) {
        super._handleChange('joining_date', data)
    }

    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Loading status={this.state.loading} text="Saving" />
                <Sidebar id="user" />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.user.menu}>{t('users:breadcrumb')} > </a>
                            </li>
                            <li>
                                <a href={route.admin.user.employee.menu}>{t('employee:breadcrumb')} > </a>
                            </li>
                            <li>
                                <a href={route.admin.user.employee.view + '/' + this.state.user_type + '/' + this.state.role_id}>{t('employee:employee.breadcrumb')} > </a>
                            </li>
                            <li>{t('employee:employee.add.breadcrumb')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                {/* <span className="sub-main-title">{ this.state.class_name && ("Class : "+this.state.class_name)}</span> */}
                                <h5 className="main-title heading5">{t('employee:employee.title')}:</h5>
                            </div>
                        </div>
                    </div>
                    <div className="main-form">
                        <div className="row clearfix">
                            <div className="col-sm-6 float-left form-group find-user">
                                <label className="form-title">{t('employee:employee.add.searchByRegCodeLabel')}</label>
                                <div className="user-load">
                                    <Input name="employee_regcode" onChange={this._handleChange} placeholder={t('employee:employee.add.searchByRegCodePlaceholder')} type="text" readOnly={this.state.found_employee && 'true'} value={this.state.employee_regcode} />
                                    {!this.state.found_employee && (
                                        <span onClick={this.findUserByRegCode.bind(this, 'employee')}>
                                            <FontAwesomeIcon className="icon" icon="search" color="#333" size="1x" />
                                        </span>
                                    )}
                                    {this.state.found_employee && (
                                        <span onClick={this.clearRegData.bind(this, 'employee')}>
                                            <FontAwesomeIcon className="icon" icon="times" color="#333" size="1x" />
                                        </span>
                                    )}
                                    {this.state.employee_regcode_error && <label className="error text-danger">{this.state.employee_regcode_error}</label>}
                                </div>
                            </div>
                        </div>
                        <hr />
                        <br />
                        <form>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('employee:employee.add.nameLabel')} *</label>
                                    <Input name="name" onChange={this._handleChange} placeholder={t('employee:employee.add.namePlaceholder')} type="text" readOnly={this.state.found_employee && 'true'} value={this.state.name} />
                                    {this.state.errors.name && <label className="error text-danger">{this.state.errors.name}</label>}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('employee:employee.add.emailLabel')}</label>
                                    <Input name="email" onChange={this._handleChange} placeholder={t('employee:employee.add.emailPlaceholder')} type="text" value={this.state.email} readOnly={this.state.found_employee && 'true'} />
                                    {this.state.errors.email && <label className="error text-danger">{this.state.errors.email}</label>}
                                </div>
                            </div>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('employee:employee.add.dobLabel')} *</label>
                                    <DatePicker dateFormat="yyyy-MM-dd" className="form-control" selected={this.state.dob} onChange={this.setDate} readOnly={this.state.found_employee && 'true'} placeholderText={t('employee:employee.add.dobplaceholder')} maxDate={moment().toDate()} />
                                    {this.props.school != null && this.props.school.school != null && this.props.school.school.date_format == 'BS' && <label className="date-bs">{this.state.dob != null ? (convertADtoBS(this.state.dob) != null ? convertADtoBS(this.state.dob) + ' BS' : 'Invalid Date Range') : ''}</label>}
                                    {this.state.errors.dob && <label className="error text-danger">{this.state.errors.dob}</label>}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('employee:employee.add.joinDateLabel')}*</label>
                                    <DatePicker dateFormat="yyyy-MM-dd" className="form-control" selected={this.state.joining_date} readOnly={this.state.found_employee && 'true'} onChange={this.setJoinDate} placeholderText={t('employee:employee.add.joinDatePlaceholder')} />
                                    {this.props.school != null && this.props.school.school != null && this.props.school.school.date_format == 'BS' && <label className="date-bs">{this.state.joining_date != null ? (convertADtoBS(this.state.joining_date) != null ? convertADtoBS(this.state.joining_date) + ' BS' : 'Invalid Date Range') : ''}</label>}
                                    {this.state.errors.joining_date && <label className="error text-danger">{this.state.errors.joining_date}</label>}
                                </div>
                            </div>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group main-select">
                                    <label className="form-title">{t('employee:employee.add.employeeCategoryLabel')}</label>
                                    <Select name="employee_category" options={this.state.employee_category} placeholder={t('employee:employee.add.employeeCategoryPlaceholder')} searchable={true} onChange={this.setEmployeeCategory} />
                                </div>
                                <div className="col-sm-6 float-left form-group main-select">
                                    <label htmlFor="departmentclass" className="form-title">
                                        {t('employee:employee.add.userTypeLabel')}*
                                    </label>
                                    <Select name="type" options={this.state.userTypeAry} placeholder={t('employee:employee.add.userTypeLabel')} searchable={true} value={this.state.defaultUserType} onChange={this._selectUserType} />
                                </div>
                            </div>
                            <div className="row clearfix" id="custom-role">
                                <div className="col-sm-6 float-left form-group main-select">
                                    <label htmlFor="departmentclass" className="form-title">
                                        {t('users:role.roleLabel')} *
                                    </label>
                                    <Select name="role" options={this.state.customRoleAry} placeholder={t('users:role.roleLabel')} searchable={true} value={this.state.defaultRole} onChange={this._selectCustomRole} />
                                </div>
                            </div>
                            <div className="row clearfix">
                                <div className="col-sm-3 float-left form-group">
                                    <Button onClick={this._onSave} type="submit" text={t('common:savebtn')} main={true} />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const EmployeeAdd = withTranslation()(connect(mapStateToProps)(EmployeeAddComponent))

export { EmployeeAdd }
